// Design: Das Aussehen (hell, dunkel, Kontrast) liefert die WohnBau App-Baseline (design.css, theme.js).
// theme.js setzt data-theme (Systemeinstellung, ?theme=) und übernimmt in Teams/Outlook das Design des Hosts.
import * as teams from '@microsoft/teams-js';

/** Farbe der Browser- bzw. Statusleiste: Seitenhintergrund des aktuellen Designs (aus design.css, nichts Festes). */
function syncBarColor(): void {
  const color = getComputedStyle(document.documentElement).getPropertyValue('--bg').trim();
  if (!color) return;
  let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.content = color;
}

export async function initTheme(): Promise<void> {
  syncBarColor();
  new MutationObserver(syncBarColor).observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });

  const query = window.matchMedia('(prefers-color-scheme: dark)');
  const hasOverride = new URLSearchParams(window.location.search).has('theme');
  const applySystem = () => {
    if (!hasOverride) document.documentElement.setAttribute('data-theme', query.matches ? 'dark' : 'default');
  };
  try {
    await Promise.race([
      teams.app.initialize(),
      new Promise((_, reject) => setTimeout(() => reject(new Error('Kein M365-Host')), 1500))
    ]);
    // theme.js erwartet das globale Objekt microsoftTeams (hier das Modul, ohne zweites initialize()).
    window.microsoftTeams = teams;
    window.WbTheme?.verbinde();
  } catch {
    query.addEventListener('change', applySystem);
  }
}
